import PropTypes from 'prop-types'
import { Colors } from 'Theme'

const BatteryProfile = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M9.5 44q-.65 0-1.075-.425Q8 43.15 8 42.5V8.7q0-.65.425-1.075Q8.85 7.2 9.5 7.2H14V4h8v3.2h4.5q.65 0 1.075.425Q28 8.05 28 8.7v33.8q0 .65-.425 1.075Q27.15 44 26.5 44Zm1.5-3h14V10.2H11Zm27.6-18.75-2.15-5-5.2-2.3 5.2-2.25 2.15-4.75 2.15 4.75 5.2 2.25-5.2 2.3ZM11 41h14Z" />
      </svg>
    </div>
  )
}

const BatteryProfileFilled = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M9.5 44q-.65 0-1.075-.425Q8 43.15 8 42.5V8.7q0-.65.425-1.075Q8.85 7.2 9.5 7.2H14V4h8v3.2h4.5q.65 0 1.075.425Q28 8.05 28 8.7v33.8q0 .65-.425 1.075Q27.15 44 26.5 44Zm29.1-21.75-2.15-5-5.2-2.3 5.2-2.25 2.15-4.75 2.15 4.75 5.2 2.25-5.2 2.3Z" />{' '}
      </svg>
    </div>
  )
}

const Tune = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M21.35 42V30.75h3v4.15H42v3H24.35V42ZM6 37.9v-3h12.35v3Zm9.35-8.3v-4.1H6v-3h9.35v-4.2h3v11.3Zm6-4.1v-3H42v3Zm8.3-8.25V6h3v4.1H42v3h-9.35v4.15ZM6 13.1v-3h20.65v3Z" />
      </svg>
    </div>
  )
}

const FindInPage = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M24 30.4q1.85 0 3.1-1.25t1.25-3.1q0-1.85-1.25-3.1T24 21.7q-1.85 0-3.1 1.25t-1.25 3.1q0 1.85 1.25 3.1T24 30.4ZM36.8 41l-8.7-8.7q-1 .6-1.975.85-.975.25-2.125.25-3.1 0-5.225-2.125-2.125-2.125-2.125-5.225 0-3.1 2.125-5.225Q20.9 18.7 24 18.7q3.1 0 5.225 2.125 2.125 2.125 2.125 5.225 0 1.15-.325 2.2-.325 1.05-.975 1.85L37 37.05V16.9L28.4 7H11v34ZM11 44q-1.2 0-2.1-.9Q8 42.2 8 41V7q0-1.2.9-2.1Q9.8 4 11 4h18.6L40 15.95V41q0 1.2-.9 2.1-.9.9-2.1.9Zm14.5-18.9Z" />
      </svg>
    </div>
  )
}

const FindInPageFilled = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M24 30.4q1.85 0 3.1-1.25t1.25-3.1q0-1.85-1.25-3.1T24 21.7q-1.85 0-3.1 1.25t-1.25 3.1q0 1.85 1.25 3.1T24 30.4ZM11 44q-1.2 0-2.1-.9Q8 42.2 8 41V7q0-1.2.9-2.1Q9.8 4 11 4h18.6L40 15.95v24.1l-9.95-9.95q.65-.8.975-1.85.325-1.05.325-2.2 0-3.1-2.125-5.225Q27.1 18.7 24 18.7q-3.1 0-5.225 2.125-2.125 2.125-2.125 5.225 0 3.1 2.125 5.225Q20.9 33.4 24 33.4q1.15 0 2.125-.25.975-.25 1.975-.85L39 43.2q-.4.4-.95.6-.55.2-1.05.2Z" />{' '}
      </svg>
    </div>
  )
}

const DeleteSweep = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M30 36.5v-3h7.25v3Zm0-18.4v-3h14v3Zm0 9.2v-3h11.75v3ZM6.25 14.25H4v-3h8.5V9h6.75v2.25h8.5v3H25.5V35q0 1.2-.9 2.1-.9.9-2.1.9H9.25q-1.2 0-2.1-.9-.9-.9-.9-2.1Zm3 0V35H22.5V14.25Zm0 0V35Z" />
      </svg>
    </div>
  )
}

const DeleteSweepFilled = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M30 36.5v-3h7.25v3Zm0-18.4v-3h14v3Zm0 9.2v-3h11.75v3ZM6.25 14.25H4v-3h8.5V9h6.75v2.25h8.5v3H25.5V35q0 1.2-.9 2.1-.9.9-2.1.9H9.25q-1.2 0-2.1-.9-.9-.9-.9-2.1Z" />{' '}
      </svg>
    </div>
  )
}

const SystemUpdate = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M7 40q-1.2 0-2.1-.9Q4 38.2 4 37V11q0-1.2.9-2.1Q5.8 8 7 8h12.5v3H7v26h34V11H28.5V8H41q1.2 0 2.1.9.9.9.9 2.1v26q0 1.2-.9 2.1-.9.9-2.1.9Zm17-9.25-10-10 2.15-2.15 6.35 6.35V8h3v16.95l6.35-6.35L34 20.75Z" />
      </svg>
    </div>
  )
}

const Restart = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M22.55 41.9q-6.15-.5-10.35-5.05Q8 32.3 8 26.05q0-3.85 1.775-7.25t4.975-5.55l2.15 2.15q-2.8 1.65-4.35 4.525Q11 22.8 11 26.05q0 5 3.3 8.65 3.3 3.65 8.25 4.2Zm3 0v-3q5-.6 8.25-4.225 3.25-3.625 3.25-8.625 0-5.45-3.775-9.225Q29.5 13.05 24.05 13.05h-1l3 3-2.15 2.15-6.65-6.65L23.9 4.9l2.15 2.15-3 3h1q6.7 0 11.35 4.675 4.65 4.675 4.65 11.325 0 6.25-4.175 10.8Q31.7 41.4 25.55 41.9Z" />
      </svg>
    </div>
  )
}

const Edit = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M200-200h50.461l409.463-409.463-50.461-50.461L200-250.461V-200Zm-59.999 59.999v-135.383l527.616-527.384q9.073-8.241 20.036-12.736 10.963-4.495 22.993-4.495 12.029 0 23.307 4.27 11.277 4.269 19.969 13.576l48.846 49.461q9.308 8.692 13.269 20.004 3.962 11.311 3.962 22.622 0 12.065-4.121 23.028-4.12 10.964-13.11 20.037l-527.384 527H140.001Zm620.384-570.153-50.231-50.231 50.231 50.231Zm-126.134 75.903-24.788-25.673 50.461 50.461-25.673-24.788Z" />
      </svg>
    </div>
  )
}

const Done = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M18.9 35.7 7.7 24.5l2.15-2.15 9.05 9.05 19.2-19.2 2.15 2.15Z" />
      </svg>
    </div>
  )
}

const Cancel = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="m12.45 37.65-2.1-2.1L21.9 24 10.35 12.45l2.1-2.1L24 21.9l11.55-11.55 2.1 2.1L26.1 24l11.55 11.55-2.1 2.1L24 26.1Z" />
      </svg>
    </div>
  )
}

const Delete = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M13.05 42q-1.25 0-2.125-.875T10.05 39V10.5H8v-3h9.4V6h13.2v1.5H40v3h-2.05V39q0 1.2-.9 2.1-.9.9-2.1.9Zm21.9-31.5h-21.9V39h21.9Zm-16.6 24.2h3V14.75h-3Zm8.3 0h3V14.75h-3Zm-13.6-24.2V39Z" />
      </svg>
    </div>
  )
}

const DeleteFilled = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M13.05 42q-1.2 0-2.1-.9-.9-.9-.9-2.1V10.5H8v-3h9.4V6h13.2v1.5H40v3h-2.05V39q0 1.2-.9 2.1-.9.9-2.1.9Zm5.3-7.3h3V14.75h-3Zm8.3 0h3V14.75h-3Z" />
      </svg>
    </div>
  )
}

const Move = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M13.55 42 4 32.45l9.6-9.6 2.1 2.1-6 6h32.45v3H9.7l5.95 5.95Zm20.9-16.85-2.1-2.1 5.95-5.95H5.85v-3H38.3l-6-6L34.4 6l9.6 9.6Z" />
      </svg>
    </div>
  )
}

const Card = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M12 39q-2.9 0-4.95-2.05Q5 34.9 5 32V16q0-2.9 2.05-4.95Q9.1 9 12 9h24q2.9 0 4.95 2.05Q43 13.1 43 16v16q0 2.9-2.05 4.95Q38.9 39 36 39Zm0-22.15h24q1.4 0 2.6.475 1.2.475 2.15 1.375V16q0-2-1.375-3.375T36 11.25H12q-2 0-3.375 1.375T7.25 16v2.7q.95-.9 2.15-1.375t2.6-.475Zm-4.65 6.2L31 28.8q.3.05.675 0 .375-.05.575-.3l8-6.7q-.55-1.2-1.7-1.925-1.15-.725-2.55-.725H12q-1.75 0-3.05 1.125-1.3 1.125-1.6 2.775Z" />
      </svg>
    </div>
  )
}

const Admin = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M34.4 34.35q1.3 0 2.2-.925.9-.925.9-2.175 0-1.3-.925-2.2-.925-.9-2.175-.9-1.3 0-2.225.9t-.925 2.15q0 1.3.925 2.225t2.225.925Zm-.05 6.2q1.65 0 3-.7t2.25-1.95q-1.25-.7-2.55-1.05-1.3-.35-2.7-.35-1.35 0-2.675.35-1.325.35-2.525 1.05.9 1.25 2.225 1.95 1.325.7 2.975.7Zm.1 2.45q-3.55 0-6.05-2.525T25.9 34.5q0-3.6 2.5-6.125t6.1-2.525q3.5 0 6.025 2.525Q43.05 30.9 43.05 34.5q0 3.45-2.525 5.975Q38 43 34.45 43ZM24 42.95q-6.45-1.65-10.725-7.525Q9 29.55 9 22V10.65l15-5.6 15 5.6v12.9q-1.05-.45-2.2-.7-1.15-.25-2.3-.25-4.95 0-8.4 3.475T22.65 34.5q0 2.05.775 4.125t2.325 3.725q-.45.25-.9.375t-.85.225Z" />
      </svg>
    </div>
  )
}

const Globe = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M24 43q-3.95 0-7.425-1.5Q13.1 40 10.55 37.45 8 34.9 6.5 31.425 5 27.95 5 24q0-3.95 1.5-7.425Q8 13.1 10.55 10.55 13.1 8 16.575 6.5 20.05 5 24 5q3.95 0 7.425 1.5Q34.9 8 37.45 10.55 40 13.1 41.5 16.575 43 20.05 43 24q0 3.95-1.5 7.425Q40 34.9 37.45 37.45 34.9 40 31.425 41.5 27.95 43 24 43Zm-2.1-2.35V36.6q-1.75 0-2.925-1.25-1.175-1.25-1.175-3V30.2L7.7 20.15q-.2.95-.325 1.9T7.25 24q0 6.4 4.175 11.15t10.475 5.5Zm14.45-5.3q1.05-1.15 1.875-2.5t1.4-2.8q.575-1.45.85-2.975.275-1.525.275-3.075 0-5.2-2.85-9.475-2.85-4.275-7.65-6.225v.95q0 1.7-1.175 2.975Q27.9 13.5 26.15 13.5H21.9v4.25q0 .85-.65 1.4-.65.55-1.5.55h-4.1V24H28.3q.85 0 1.4.625.55.625.55 1.475v6.25h2.1q1.45 0 2.525.825t1.475 2.175Z" />
      </svg>
    </div>
  )
}

const Expand = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="m24 31.05-12.3-12.3 2.45-2.45L24 26.2l9.85-9.85 2.45 2.45Z" />
      </svg>
    </div>
  )
}

const Add = ({ className, height = 36, width = 36, fill = Colors.primary }) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M22.85 37.5V25.15H10.5v-2.3h12.35V10.5h2.3v12.35H37.5v2.3H25.15V37.5Z" />
      </svg>
    </div>
  )
}

const Flash = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="ionicon"
        viewBox="0 0 512 512"
        fill={fill}
      >
        <path d="M194.82 496a18.36 18.36 0 01-18.1-21.53v-.11L204.83 320H96a16 16 0 01-12.44-26.06L302.73 23a18.45 18.45 0 0132.8 13.71c0 .3-.08.59-.13.89L307.19 192H416a16 16 0 0112.44 26.06L209.24 489a18.45 18.45 0 01-14.42 7z" />
      </svg>
    </div>
  )
}

const FlashMaterial = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="m19 41.1 2-13.7h-8.05L27 7.15 25.05 22.6h9.4L19 41.1Z" />
      </svg>
    </div>
  )
}

const Start = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M19.6 31.7 31.7 24l-12.1-7.7ZM24 43q-3.9 0-7.375-1.5t-6.05-4.075Q8 34.85 6.5 31.375 5 27.9 5 24q0-3.95 1.5-7.425Q8 13.1 10.575 10.55 13.15 8 16.625 6.5 20.1 5 24 5q3.95 0 7.425 1.5Q34.9 8 37.45 10.55 40 13.1 41.5 16.575 43 20.05 43 24q0 3.9-1.5 7.375t-4.05 6.05Q34.9 40 31.425 41.5 27.95 43 24 43Zm0-2.25q7 0 11.875-4.9T40.75 24q0-7-4.875-11.875T24 7.25q-6.95 0-11.85 4.875Q7.25 17 7.25 24q0 6.95 4.9 11.85 4.9 4.9 11.85 4.9ZM24 24Z" />
      </svg>
    </div>
  )
}

const Stop = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M16.85 31.15h14.3v-14.3h-14.3ZM24 43q-3.95 0-7.4-1.5t-6.025-4.075Q8 34.85 6.5 31.4T5 24q0-3.95 1.5-7.425Q8 13.1 10.575 10.55 13.15 8 16.6 6.5T24 5q3.95 0 7.425 1.5Q34.9 8 37.45 10.55 40 13.1 41.5 16.575 43 20.05 43 24q0 3.95-1.5 7.4t-4.05 6.025Q34.9 40 31.425 41.5 27.95 43 24 43Zm.05-2.25q6.95 0 11.825-4.9 4.875-4.9 4.875-11.9 0-6.95-4.875-11.825Q31 7.25 24 7.25q-6.95 0-11.85 4.875Q7.25 17 7.25 24q0 6.95 4.9 11.85 4.9 4.9 11.9 4.9ZM24 24Z" />
      </svg>
    </div>
  )
}

const Unlock = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M11.9 17.2h18.45v-4.55q0-2.65-1.85-4.525Q26.65 6.25 24 6.25t-4.5 1.875Q17.65 10 17.65 12.65h-2.3q0-3.6 2.525-6.125T24 4q3.6 0 6.125 2.525t2.525 6.125v4.55h3.45q1.2 0 2.05.85.85.85.85 2.05v20q0 1.2-.85 2.05-.85.85-2.05.85H11.9q-1.2 0-2.05-.85Q9 41.3 9 40.1v-20q0-1.2.85-2.05.85-.85 2.05-.85Zm0 23.55h24.2q.3 0 .475-.175t.175-.475v-20q0-.25-.175-.425T36.1 19.5H11.9q-.3 0-.475.175t-.175.425v20q0 .3.175.475t.475.175ZM24 33.5q1.4 0 2.4-.975t1-2.375q0-1.3-1-2.375T24 26.7q-1.4 0-2.4 1.075t-1 2.425q0 1.35 1 2.325 1 .975 2.4.975Zm-12.75 7.25V19.5 40.75Z" />
      </svg>
    </div>
  )
}

const UnlockFilled = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M11.9 17.2h18.45v-4.55q0-2.65-1.85-4.525Q26.65 6.25 24 6.25t-4.5 1.875Q17.65 10 17.65 12.65h-2.3q0-3.6 2.525-6.125T24 4q3.6 0 6.125 2.525t2.525 6.125v4.55h3.45q1.2 0 2.05.85.85.85.85 2.05v20q0 1.2-.85 2.05-.85.85-2.05.85H11.9q-1.2 0-2.05-.85Q9 41.3 9 40.1v-20q0-1.2.85-2.05.85-.85 2.05-.85ZM24 33.5q1.4 0 2.4-.975t1-2.375q0-1.3-1-2.375T24 26.7q-1.4 0-2.4 1.075t-1 2.425q0 1.35 1 2.325 1 .975 2.4.975Z" />
      </svg>
    </div>
  )
}

const StopFilled = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M16.85 31.15h14.3v-14.3h-14.3ZM24 43q-3.9 0-7.375-1.5t-6.05-4.075Q8 34.85 6.5 31.375 5 27.9 5 24q0-3.95 1.5-7.425Q8 13.1 10.575 10.55 13.15 8 16.625 6.5 20.1 5 24 5q3.95 0 7.425 1.5Q34.9 8 37.45 10.55 40 13.1 41.5 16.575 43 20.05 43 24q0 3.9-1.5 7.375t-4.05 6.05Q34.9 40 31.425 41.5 27.95 43 24 43Z" />
      </svg>
    </div>
  )
}

const StartFilled = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M19.6 31.7 31.7 24l-12.1-7.7ZM24 43q-3.9 0-7.375-1.5t-6.05-4.075Q8 34.85 6.5 31.375 5 27.9 5 24q0-3.95 1.5-7.425Q8 13.1 10.575 10.55 13.15 8 16.625 6.5 20.1 5 24 5q3.95 0 7.425 1.5Q34.9 8 37.45 10.55 40 13.1 41.5 16.575 43 20.05 43 24q0 3.9-1.5 7.375t-4.05 6.05Q34.9 40 31.425 41.5 27.95 43 24 43Z" />
      </svg>
    </div>
  )
}

const ArrowUpSort = ({ height = 36, width = 36, fill = Colors.primary }) => {
  return (
    <div style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 480h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32z" />
      </svg>
    </div>
  )
}

const ArrowDownSort = ({ height = 36, width = 36, fill = Colors.primary }) => {
  return (
    <div style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 576 512" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320z" />
      </svg>
    </div>
  )
}

const Sync = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M8.35 40v-3h6.5l-.75-.6q-3.2-2.55-4.65-5.55-1.45-3-1.45-6.7 0-5.3 3.125-9.525Q14.25 10.4 19.35 8.8v3.1q-3.75 1.45-6.05 4.825T11 24.15q0 3.15 1.175 5.475 1.175 2.325 3.175 4.025l1.5 1.05v-6.2h3V40Zm20.35-.75V36.1q3.8-1.45 6.05-4.825T37 23.85q0-2.4-1.175-4.875T32.75 14.6l-1.45-1.3v6.2h-3V8h11.5v3h-6.55l.75.7q3 2.8 4.5 6t1.5 6.15q0 5.3-3.1 9.55-3.1 4.25-8.2 5.85Z" />
      </svg>
    </div>
  )
}
const CloudDownload = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M12.55 40q-4.4 0-7.475-3.075Q2 33.85 2 29.45q0-3.95 2.525-6.875t6.325-3.525q.75-4.2 4.1-7.425Q18.3 8.4 22.55 8.4q1.2 0 2.1.675.9.675.9 1.825v14.7l4.15-4.15 2.15 2.15-7.8 7.8-7.8-7.8 2.15-2.15 4.15 4.15V11.15q-4.3.55-6.75 3.775-2.45 3.225-2.45 6.975h-.95q-3.05 0-5.225 2.15T5 29.45q0 3.25 2.25 5.4Q9.5 37 12.55 37h25q2.25 0 3.85-1.6t1.6-3.85q0-2.25-1.6-3.85t-3.85-1.6H34.4v-4.2q0-3.4-1.65-5.875T28.5 12.1V8.85q4.05 1.45 6.475 5.05 2.425 3.6 2.425 8v1.2q3.6-.1 6.1 2.3 2.5 2.4 2.5 6.15 0 3.45-2.5 5.95T37.55 40ZM24 22.65Z" />
      </svg>
    </div>
  )
}
const CloudDownloadFill = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M12.55 40q-4.4 0-7.475-3.075Q2 33.85 2 29.45q0-3.9 2.5-6.85 2.5-2.95 6.35-3.55.9-4.5 4.15-7.5 3.25-3 7.55-3.4V25.6l-4.15-4.15-2.15 2.15 7.8 7.8 7.8-7.8-2.15-2.15-4.15 4.15V8.15q5.05.55 8.45 4.5 3.4 3.95 3.4 9.25v1.2q3.6-.1 6.1 2.325Q46 27.85 46 31.55q0 3.45-2.5 5.95T37.55 40Z" />
      </svg>
    </div>
  )
}
const Terminal = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M7 40q-1.2 0-2.1-.9Q4 38.2 4 37V11q0-1.2.9-2.1Q5.8 8 7 8h34q1.2 0 2.1.9.9.9.9 2.1v26q0 1.2-.9 2.1-.9.9-2.1.9Zm0-3h34V15.2H7V37Zm8-3.6-2.1-2.1 5.15-5.2-5.2-5.2L15 18.8l7.3 7.3Zm9.5.2v-3h11v3Z" />
      </svg>
    </div>
  )
}

const EventNote = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M9.9 43q-1.2 0-2.05-.85Q7 41.3 7 40.1V11.15q0-1.15.85-2.025T9.9 8.25h3.7v-3.5h2.5v3.5H32v-3.5h2.45v3.5h3.65q1.2 0 2.05.875Q41 10 41 11.15V40.1q0 1.2-.85 2.05-.85.85-2.05.85Zm0-2.25h28.2q.25 0 .45-.2t.2-.45V20.25H9.25V40.1q0 .25.2.45t.45.2ZM9.25 18h29.5v-6.85q0-.25-.2-.425t-.45-.175H9.9q-.25 0-.45.175t-.2.425Zm0 0V10.55 18Zm5.25 8.75V24.5h19v2.25Zm0 8.75v-2.25h12.95v2.25Z" />{' '}
      </svg>
    </div>
  )
}
const EventNoteFill = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M14.5 26.75V24.5h19v2.25Zm0 8.75v-2.25h12.95v2.25ZM9.9 43q-1.2 0-2.05-.85Q7 41.3 7 40.1V11.15q0-1.15.85-2.025T9.9 8.25h3.7v-3.5h2.5v3.5H32v-3.5h2.45v3.5h3.65q1.2 0 2.05.875Q41 10 41 11.15V40.1q0 1.2-.85 2.05-.85.85-2.05.85Zm0-2.25h28.2q.25 0 .45-.2t.2-.45V20.25H9.25V40.1q0 .25.2.45t.45.2Z" />{' '}
      </svg>
    </div>
  )
}
const EventBusy = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M19.15 36.25 17.5 34.6l4.9-4.85-4.9-4.85 1.65-1.65 4.85 4.9 4.85-4.9 1.65 1.65-4.9 4.85 4.9 4.85-1.65 1.65-4.85-4.9ZM9.9 43q-1.2 0-2.05-.85Q7 41.3 7 40.1V11.15q0-1.15.85-2.025T9.9 8.25h3.7v-3.5h2.5v3.5H32v-3.5h2.45v3.5h3.65q1.2 0 2.05.875Q41 10 41 11.15V40.1q0 1.2-.85 2.05-.85.85-2.05.85Zm0-2.25h28.2q.25 0 .45-.2t.2-.45V20.25H9.25V40.1q0 .25.2.45t.45.2ZM9.25 18h29.5v-6.85q0-.25-.2-.425t-.45-.175H9.9q-.25 0-.45.175t-.2.425Zm0 0V10.55 18Z" />{' '}
      </svg>
    </div>
  )
}
const EventBusyFill = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M19.15 36.25 17.5 34.6l4.9-4.85-4.9-4.85 1.65-1.65 4.85 4.9 4.85-4.9 1.65 1.65-4.9 4.85 4.9 4.85-1.65 1.65-4.85-4.9ZM9.9 43q-1.2 0-2.05-.85Q7 41.3 7 40.1V11.15q0-1.15.85-2.025T9.9 8.25h3.7v-3.5h2.5v3.5H32v-3.5h2.45v3.5h3.65q1.2 0 2.05.875Q41 10 41 11.15V40.1q0 1.2-.85 2.05-.85.85-2.05.85Zm0-2.25h28.2q.25 0 .45-.2t.2-.45V20.25H9.25V40.1q0 .25.2.45t.45.2Z" />{' '}
      </svg>
    </div>
  )
}
const Timelapse = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M24 38q5.85 0 9.925-4.075Q38 29.85 38 24q0-5.85-4.075-9.925Q29.85 10 24 10v14l-9.55 10q1.85 1.95 4.35 2.975Q21.3 38 24 38Zm0 6q-4.1 0-7.75-1.575-3.65-1.575-6.375-4.3-2.725-2.725-4.3-6.375Q4 28.1 4 24q0-4.15 1.575-7.8 1.575-3.65 4.3-6.35 2.725-2.7 6.375-4.275Q19.9 4 24 4q4.15 0 7.8 1.575 3.65 1.575 6.35 4.275 2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.275 6.375t-6.35 4.3Q28.15 44 24 44Zm0-3q7.1 0 12.05-4.975Q41 31.05 41 24q0-7.1-4.95-12.05Q31.1 7 24 7q-7.05 0-12.025 4.95Q7 16.9 7 24q0 7.05 4.975 12.025Q16.95 41 24 41Zm0-17Z" />
      </svg>
    </div>
  )
}

const File = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M11 44q-1.2 0-2.1-.9Q8 42.2 8 41V7q0-1.2.9-2.1Q9.8 4 11 4h18.05L40 14.95V41q0 1.2-.9 2.1-.9.9-2.1.9Zm16.55-27.7V7H11v34h26V16.3ZM11 7v9.3V7v34V7Z" />
      </svg>
    </div>
  )
}

const Error = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M24 34q.7 0 1.175-.475.475-.475.475-1.175 0-.7-.475-1.175Q24.7 30.7 24 30.7q-.7 0-1.175.475-.475.475-.475 1.175 0 .7.475 1.175Q23.3 34 24 34Zm-1.35-7.65h3V13.7h-3ZM24 44q-4.1 0-7.75-1.575-3.65-1.575-6.375-4.3-2.725-2.725-4.3-6.375Q4 28.1 4 23.95q0-4.1 1.575-7.75 1.575-3.65 4.3-6.35 2.725-2.7 6.375-4.275Q19.9 4 24.05 4q4.1 0 7.75 1.575 3.65 1.575 6.35 4.275 2.7 2.7 4.275 6.35Q44 19.85 44 24q0 4.1-1.575 7.75-1.575 3.65-4.275 6.375t-6.35 4.3Q28.15 44 24 44Zm.05-3q7.05 0 12-4.975T41 23.95q0-7.05-4.95-12T24 7q-7.05 0-12.025 4.95Q7 16.9 7 24q0 7.05 4.975 12.025Q16.95 41 24.05 41ZM24 24Z" />
      </svg>
    </div>
  )
}

const Refresh = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M24 40q-6.65 0-11.325-4.675Q8 30.65 8 24q0-6.65 4.675-11.325Q17.35 8 24 8q4.25 0 7.45 1.725T37 14.45V8h3v12.7H27.3v-3h8.4q-1.9-3-4.85-4.85Q27.9 11 24 11q-5.45 0-9.225 3.775Q11 18.55 11 24q0 5.45 3.775 9.225Q18.55 37 24 37q4.15 0 7.6-2.375 3.45-2.375 4.8-6.275h3.1q-1.45 5.25-5.75 8.45Q29.45 40 24 40Z" />
      </svg>
    </div>
  )
}

const RemoveRounded = ({ height = 36, width = 36, fill = Colors.primary }) => {
  return (
    <div style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M14.5 25h19v-2.25h-19ZM24 43q-3.9 0-7.375-1.5t-6.05-4.075Q8 34.85 6.5 31.375 5 27.9 5 24q0-3.95 1.5-7.425Q8 13.1 10.575 10.55 13.15 8 16.625 6.5 20.1 5 24 5q3.95 0 7.425 1.5Q34.9 8 37.45 10.55 40 13.1 41.5 16.575 43 20.05 43 24q0 3.9-1.5 7.375t-4.05 6.05Q34.9 40 31.425 41.5 27.95 43 24 43Z" />
      </svg>
    </div>
  )
}

const AddRounded = ({ height = 36, width = 36, fill = Colors.primary }) => {
  return (
    <div style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M23 33.5h2.25v-8.2h8.25V23h-8.25v-8.5H23V23h-8.5v2.3H23Zm1 9.5q-3.95 0-7.4-1.5t-6.025-4.075Q8 34.85 6.5 31.4T5 24q0-3.95 1.5-7.425Q8 13.1 10.575 10.55 13.15 8 16.6 6.5T24 5q3.95 0 7.425 1.5Q34.9 8 37.45 10.55 40 13.1 41.5 16.575 43 20.05 43 24q0 3.95-1.5 7.4t-4.05 6.025Q34.9 40 31.425 41.5 27.95 43 24 43Z" />
      </svg>
    </div>
  )
}

const GoBack = ({ height = 36, width = 36, fill = Colors.primary }) => {
  return (
    <div style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M28.05 36.3 15.7 23.95 28.05 11.6l2.45 2.45-9.9 9.9 9.9 9.9Z" />
      </svg>
    </div>
  )
}

const Email = ({ height = 36, width = 36, fill = Colors.primary }) => {
  return (
    <div style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48" // size of image before scaling
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M7.9 39q-1.2 0-2.05-.85Q5 37.3 5 36.1V11.9q0-1.2.85-2.05Q6.7 9 7.9 9h32.2q1.2 0 2.05.85.85.85.85 2.05v24.2q0 1.2-.85 2.05-.85.85-2.05.85ZM24 24.3 7.25 13.25V36.1q0 .3.175.475t.475.175h32.2q.3 0 .475-.175t.175-.475V13.25Zm0-2.4 16.3-10.65H7.75ZM7.25 13.25v-2V36.1q0 .3.175.475t.475.175h-.65V36.1Z" />
      </svg>
    </div>
  )
}

const RFID = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 96 960 960"
        fill={fill}
      >
        <path d="M880 316v520q0 24-18 42t-42 18H140q-24 0-42-18t-18-42V316q0-24 18-42t42-18h680q24 0 42 18t18 42ZM140 425h680V316H140v109Zm0 129v282h680V554H140Zm0 282V316v520Z" />
      </svg>
    </div>
  )
}
const Tag = ({ height = 36, width = 36, fill = Colors.primary }) => {
  return (
    <div style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 96 960 960"
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="m250 896 43-170H140l15-60h153l45-180H180l15-60h173l42-170h59l-42 170h181l42-170h59l-42 170h153l-15 60H652l-45 180h173l-15 60H592l-42 170h-60l43-170H352l-42 170h-60Zm117-230h181l45-180H412l-45 180Z" />
      </svg>
    </div>
  )
}

const VirtualToken = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 96 960 960"
        fill={fill}
      >
        <path d="M360 896q-134 0-227-93T40 576q0-134 93-227t227-93q134 0 227 93t93 227q0 134-93 227t-227 93Zm-30-190h60V506h80v-40H250v40h80v200Zm454-298-42-94-94-42 94-42 42-94 42 94 94 42-94 42-42 94Zm0 608-42-94-94-42 94-42 42-94 42 94 94 42-94 42-42 94Z" />
      </svg>
    </div>
  )
}
const VisibleFilled = ({ height = 36, width = 36, fill = Colors.primary }) => {
  return (
    <div style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 96 960 960"
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M480.118 726Q551 726 600.5 676.382q49.5-49.617 49.5-120.5Q650 485 600.382 435.5q-49.617-49.5-120.5-49.5Q409 386 359.5 435.618q-49.5 49.617-49.5 120.5Q310 627 359.618 676.5q49.617 49.5 120.5 49.5Zm-.353-58Q433 668 400.5 635.265q-32.5-32.736-32.5-79.5Q368 509 400.735 476.5q32.736-32.5 79.5-32.5Q527 444 559.5 476.735q32.5 32.736 32.5 79.5Q592 603 559.265 635.5q-32.736 32.5-79.5 32.5ZM480 856q-146 0-264-83T40 556q58-134 176-217t264-83q146 0 264 83t176 217q-58 134-176 217t-264 83Z" />
      </svg>
    </div>
  )
}

const Caution = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 96 960 960"
        fill={fill}
      >
        <path d="M479.982 776q14.018 0 23.518-9.482 9.5-9.483 9.5-23.5 0-14.018-9.482-23.518-9.483-9.5-23.5-9.5-14.018 0-23.518 9.482-9.5 9.483-9.5 23.5 0 14.018 9.482 23.518 9.483 9.5 23.5 9.5ZM453 623h60V370h-60v253Zm27.266 353q-82.734 0-155.5-31.5t-127.266-86q-54.5-54.5-86-127.341Q80 658.319 80 575.5q0-82.819 31.5-155.659Q143 347 197.5 293t127.341-85.5Q397.681 176 480.5 176q82.819 0 155.659 31.5Q709 239 763 293t85.5 127Q880 493 880 575.734q0 82.734-31.5 155.5T763 858.316q-54 54.316-127 86Q563 976 480.266 976Z" />
      </svg>
    </div>
  )
}

const EncodedUnlock = (fill = Colors.primary) => {
  return encodeURIComponent(`<svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-120 -24 1200 1200"
      fill="${fill}"
    >
      <path d="M237.694 440.463h369.613v-91.769q0-53.013-37.113-90.16-37.113-37.148-90.076-37.148-52.964 0-90.195 37.148-37.23 37.147-37.23 90.16h-45.384q0-72.076 50.413-122.384 50.414-50.307 122.384-50.307t122.278 50.382q50.307 50.383 50.307 122.309v91.769h69.615q23.5 0 40.596 16.904 17.097 16.904 17.097 40.788v400.151q0 23.5-17.097 40.596-17.096 17.097-40.596 17.097H237.694q-23.5 0-40.596-17.097-17.097-17.096-17.097-40.596V498.155q0-23.884 17.097-40.788 17.096-16.904 40.596-16.904Zm242.474 325.536q27.986 0 47.793-19.531 19.808-19.531 19.808-47.007 0-26.538-19.976-47.768-19.976-21.231-47.961-21.231-27.986 0-47.793 21.231-19.808 21.23-19.808 48.268 0 27.039 19.976 46.538 19.976 19.5 47.961 19.5Z" />
    </svg>`)
}

const EncodedLock = (fill = Colors.primary) => {
  return encodeURIComponent(`<svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-120 -24 1200 1200"
      fill="${fill}"
    >
      <path d="M237.694 955.999q-23.5 0-40.596-17.097-17.097-17.096-17.097-40.596V498.155q0-23.798 17.097-40.745 17.096-16.947 40.596-16.947h69.615v-91.769q0-71.89 50.439-122.29 50.439-50.401 122.384-50.401 71.944 0 122.252 50.401 50.307 50.4 50.307 122.29v91.769h69.615q23.5 0 40.596 16.947 17.097 16.947 17.097 40.745v400.151q0 23.5-17.097 40.596-17.096 17.097-40.596 17.097H237.694Zm242.474-190q27.986 0 47.793-19.531 19.808-19.531 19.808-47.007 0-26.538-19.976-47.768-19.976-21.231-47.961-21.231-27.986 0-47.793 21.231-19.808 21.23-19.808 48.268 0 27.039 19.976 46.538 19.976 19.5 47.961 19.5ZM352.693 440.463h254.614v-91.769q0-53.045-37.09-90.176-37.09-37.132-90.077-37.132-52.986 0-90.217 37.132-37.23 37.131-37.23 90.176v91.769Z" />
    </svg>`)
}

const FastSpeedCharging = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="19px"
        height="19px"
        viewBox="0 0 19 19"
        fill={fill}
      >
        <g id="surface1">
          <path d="M 2.039062 0.09375 C 1.160156 0.234375 0.480469 0.804688 0.1875 1.636719 C 0.046875 2.035156 0.0546875 1.722656 0.0546875 10.644531 L 0.0546875 18.972656 L 11.789062 18.972656 L 11.789062 16.003906 C 11.789062 12.726562 11.773438 12.960938 11.96875 12.789062 L 12.066406 12.703125 L 13.085938 12.703125 C 14.046875 12.703125 14.109375 12.707031 14.195312 12.757812 C 14.390625 12.878906 14.378906 12.742188 14.398438 14.953125 C 14.414062 17.125 14.414062 17.105469 14.589844 17.53125 C 14.691406 17.78125 14.753906 17.886719 14.941406 18.113281 C 15.425781 18.722656 16.234375 19.042969 16.980469 18.929688 C 17.945312 18.785156 18.6875 18.097656 18.910156 17.128906 C 18.957031 16.953125 18.960938 16.519531 18.960938 12.109375 C 18.960938 7.597656 18.957031 7.269531 18.90625 7.089844 C 18.835938 6.800781 18.707031 6.511719 18.554688 6.304688 C 18.476562 6.199219 17.523438 5.214844 16.394531 4.078125 L 14.371094 2.039062 L 14.039062 2.371094 L 13.699219 2.703125 L 14.851562 3.855469 C 15.65625 4.664062 16.007812 5.03125 16.019531 5.089844 C 16.09375 5.375 16.003906 5.542969 15.71875 5.691406 C 15.105469 5.996094 14.667969 6.527344 14.492188 7.183594 C 14.425781 7.410156 14.421875 7.984375 14.476562 8.207031 C 14.589844 8.648438 14.777344 8.976562 15.105469 9.308594 C 15.429688 9.632812 15.757812 9.824219 16.199219 9.933594 C 16.445312 9.992188 16.972656 9.980469 17.234375 9.910156 C 17.625 9.796875 17.832031 9.84375 17.949219 10.066406 C 18 10.164062 18 10.292969 17.996094 13.589844 L 17.988281 17.019531 L 17.925781 17.175781 C 17.609375 17.960938 16.648438 18.242188 15.929688 17.765625 C 15.753906 17.644531 15.554688 17.402344 15.472656 17.195312 C 15.40625 17.042969 15.40625 17.039062 15.394531 14.976562 L 15.382812 12.910156 L 15.304688 12.691406 C 15.214844 12.441406 15.121094 12.296875 14.929688 12.121094 C 14.738281 11.933594 14.65625 11.882812 14.40625 11.796875 L 14.1875 11.722656 L 13.113281 11.703125 L 12.042969 11.691406 L 11.953125 11.609375 C 11.90625 11.558594 11.851562 11.5 11.835938 11.46875 C 11.8125 11.425781 11.800781 10.207031 11.789062 6.683594 C 11.769531 1.480469 11.785156 1.914062 11.605469 1.46875 C 11.402344 0.972656 10.914062 0.480469 10.40625 0.261719 C 9.917969 0.0585938 10.238281 0.0703125 6.035156 0.0664062 C 3.101562 0.0585938 2.210938 0.0664062 2.039062 0.09375 Z M 9.925781 1.078125 C 10.371094 1.21875 10.726562 1.617188 10.816406 2.078125 C 10.835938 2.179688 10.847656 4.804688 10.847656 9.933594 C 10.847656 17.554688 10.847656 17.640625 10.792969 17.753906 C 10.757812 17.808594 10.695312 17.886719 10.648438 17.925781 L 10.554688 17.988281 L 1.292969 17.988281 L 1.203125 17.925781 C 1.15625 17.890625 1.09375 17.820312 1.074219 17.769531 C 1.027344 17.683594 1.027344 17.015625 1.027344 9.878906 C 1.027344 2.105469 1.027344 2.078125 1.082031 1.910156 C 1.21875 1.511719 1.507812 1.222656 1.898438 1.082031 C 2.0625 1.027344 2.113281 1.027344 5.914062 1.027344 C 9.613281 1.027344 9.765625 1.027344 9.925781 1.078125 Z M 17.160156 6.484375 C 17.523438 6.625 17.832031 6.953125 17.945312 7.320312 C 18.015625 7.550781 18.019531 7.898438 17.949219 8.125 C 17.746094 8.78125 17.039062 9.167969 16.378906 9 C 15.917969 8.878906 15.59375 8.585938 15.449219 8.164062 C 15.371094 7.9375 15.371094 7.507812 15.453125 7.269531 C 15.574219 6.910156 15.910156 6.585938 16.292969 6.464844 C 16.511719 6.390625 16.945312 6.398438 17.160156 6.484375 Z M 17.160156 6.484375 " />
          <path d="M 5.78125 3.402344 C 5.371094 3.992188 4.726562 4.917969 4.347656 5.457031 C 3.972656 6 3.664062 6.453125 3.664062 6.464844 C 3.664062 6.480469 4.03125 6.492188 4.488281 6.492188 L 5.3125 6.492188 L 5.253906 6.914062 C 5.222656 7.144531 5.125 7.769531 5.046875 8.300781 C 4.96875 8.835938 4.910156 9.273438 4.914062 9.28125 C 4.921875 9.285156 5.03125 9.164062 5.160156 9.007812 C 5.292969 8.851562 6.007812 8 6.75 7.113281 L 8.101562 5.507812 L 6.171875 5.476562 L 6.179688 5.410156 C 6.183594 5.34375 6.40625 3.582031 6.511719 2.722656 C 6.539062 2.507812 6.558594 2.332031 6.550781 2.332031 C 6.539062 2.332031 6.195312 2.8125 5.78125 3.402344 Z M 5.78125 3.402344 " />
          <path d="M 5.78125 10.78125 C 5.371094 11.375 4.726562 12.292969 4.347656 12.835938 C 3.972656 13.378906 3.664062 13.832031 3.664062 13.839844 C 3.664062 13.855469 4.03125 13.867188 4.488281 13.867188 L 5.3125 13.867188 L 5.253906 14.289062 C 5.222656 14.523438 5.125 15.152344 5.046875 15.679688 C 4.96875 16.214844 4.910156 16.65625 4.914062 16.660156 C 4.921875 16.664062 5.03125 16.539062 5.160156 16.382812 C 5.292969 16.226562 6.007812 15.378906 6.75 14.492188 L 8.101562 12.882812 L 6.171875 12.855469 L 6.179688 12.789062 C 6.183594 12.722656 6.40625 10.957031 6.511719 10.101562 C 6.539062 9.886719 6.558594 9.707031 6.550781 9.707031 C 6.539062 9.707031 6.195312 10.191406 5.78125 10.78125 Z M 5.78125 10.78125 " />
        </g>
      </svg>
    </div>
  )
}

const NormalSpeedCharging = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="19px"
        height="19px"
        viewBox="0 0 19 19"
        fill={fill}
      >
        <g id="surface1">
          <path d="M 2.039062 0.09375 C 1.164062 0.234375 0.476562 0.804688 0.1875 1.636719 C 0.0507812 2.035156 0.0546875 1.722656 0.0546875 10.644531 L 0.0546875 18.976562 L 11.792969 18.976562 L 11.792969 16.007812 C 11.792969 12.730469 11.777344 12.964844 11.972656 12.792969 L 12.070312 12.707031 L 13.089844 12.707031 C 14.050781 12.707031 14.113281 12.710938 14.199219 12.761719 C 14.398438 12.882812 14.382812 12.746094 14.402344 14.953125 C 14.417969 17.128906 14.417969 17.109375 14.59375 17.535156 C 14.695312 17.789062 14.761719 17.890625 14.945312 18.117188 C 15.433594 18.726562 16.238281 19.050781 16.984375 18.9375 C 17.953125 18.792969 18.691406 18.105469 18.917969 17.136719 C 18.960938 16.957031 18.964844 16.523438 18.964844 12.109375 C 18.964844 7.597656 18.960938 7.273438 18.914062 7.09375 C 18.84375 6.804688 18.710938 6.515625 18.5625 6.304688 C 18.484375 6.199219 17.527344 5.214844 16.398438 4.078125 L 14.375 2.039062 L 14.042969 2.371094 L 13.707031 2.703125 L 14.855469 3.855469 C 15.664062 4.667969 16.011719 5.03125 16.027344 5.089844 C 16.097656 5.375 16.007812 5.546875 15.722656 5.691406 C 15.113281 6 14.675781 6.53125 14.496094 7.1875 C 14.429688 7.414062 14.425781 7.988281 14.480469 8.210938 C 14.59375 8.652344 14.78125 8.980469 15.105469 9.308594 C 15.433594 9.636719 15.761719 9.824219 16.203125 9.9375 C 16.449219 9.996094 16.976562 9.984375 17.238281 9.910156 C 17.625 9.800781 17.835938 9.847656 17.957031 10.070312 C 18.007812 10.164062 18.007812 10.296875 18 13.59375 L 17.992188 17.023438 L 17.929688 17.179688 C 17.613281 17.964844 16.652344 18.25 15.9375 17.769531 C 15.757812 17.652344 15.558594 17.40625 15.472656 17.203125 C 15.414062 17.050781 15.414062 17.042969 15.398438 14.984375 L 15.386719 12.914062 L 15.308594 12.695312 C 15.21875 12.445312 15.125 12.300781 14.933594 12.121094 C 14.742188 11.9375 14.65625 11.886719 14.410156 11.800781 L 14.191406 11.726562 L 13.117188 11.707031 L 12.042969 11.695312 L 11.957031 11.613281 C 11.910156 11.5625 11.855469 11.503906 11.839844 11.472656 C 11.8125 11.429688 11.804688 10.210938 11.792969 6.6875 C 11.773438 1.480469 11.789062 1.917969 11.609375 1.46875 C 11.410156 0.972656 10.917969 0.476562 10.410156 0.261719 C 9.921875 0.0585938 10.242188 0.0703125 6.035156 0.0664062 C 3.105469 0.0625 2.210938 0.0664062 2.039062 0.09375 Z M 9.929688 1.078125 C 10.375 1.21875 10.730469 1.617188 10.820312 2.078125 C 10.839844 2.179688 10.847656 4.808594 10.847656 9.9375 C 10.847656 17.5625 10.847656 17.648438 10.792969 17.757812 C 10.761719 17.816406 10.699219 17.894531 10.648438 17.929688 L 10.558594 17.992188 L 1.289062 17.992188 L 1.203125 17.933594 C 1.15625 17.894531 1.097656 17.828125 1.070312 17.773438 C 1.03125 17.6875 1.027344 17.019531 1.027344 9.878906 C 1.027344 2.105469 1.027344 2.078125 1.082031 1.910156 C 1.21875 1.511719 1.507812 1.222656 1.902344 1.085938 C 2.0625 1.03125 2.113281 1.03125 5.914062 1.027344 C 9.613281 1.027344 9.769531 1.03125 9.929688 1.078125 Z M 17.164062 6.484375 C 17.53125 6.625 17.835938 6.957031 17.953125 7.320312 C 18.023438 7.550781 18.027344 7.898438 17.953125 8.125 C 17.75 8.78125 17.042969 9.171875 16.382812 9.003906 C 15.925781 8.882812 15.597656 8.589844 15.453125 8.164062 C 15.375 7.941406 15.375 7.507812 15.457031 7.273438 C 15.578125 6.910156 15.914062 6.589844 16.292969 6.464844 C 16.519531 6.390625 16.949219 6.402344 17.164062 6.484375 Z M 17.164062 6.484375 " />
          <path d="M 5.894531 7.207031 C 5.484375 7.796875 4.839844 8.71875 4.460938 9.261719 C 4.082031 9.800781 3.773438 10.253906 3.773438 10.269531 C 3.773438 10.28125 4.140625 10.292969 4.601562 10.292969 L 5.425781 10.292969 L 5.367188 10.714844 C 5.332031 10.949219 5.238281 11.574219 5.160156 12.105469 C 5.082031 12.636719 5.023438 13.078125 5.027344 13.085938 C 5.03125 13.089844 5.144531 12.964844 5.273438 12.808594 C 5.40625 12.65625 6.121094 11.804688 6.863281 10.917969 L 8.214844 9.308594 L 7.25 9.292969 L 6.285156 9.28125 L 6.289062 9.210938 C 6.296875 9.144531 6.515625 7.382812 6.625 6.527344 C 6.652344 6.308594 6.671875 6.132812 6.660156 6.132812 C 6.652344 6.132812 6.304688 6.613281 5.894531 7.207031 Z M 5.894531 7.207031 " />
        </g>
      </svg>
    </div>
  )
}

const SuperSpeedCharging = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="19px"
        height="19px"
        viewBox="0 0 19 19"
        fill={fill}
      >
        <g id="surface1">
          <path d="M 2.039062 0.09375 C 1.164062 0.234375 0.476562 0.804688 0.1875 1.636719 C 0.0507812 2.035156 0.0546875 1.722656 0.0546875 10.644531 L 0.0546875 18.976562 L 11.792969 18.976562 L 11.792969 16.007812 C 11.792969 12.730469 11.777344 12.964844 11.972656 12.792969 L 12.070312 12.707031 L 13.089844 12.707031 C 14.050781 12.707031 14.113281 12.710938 14.199219 12.761719 C 14.398438 12.882812 14.382812 12.746094 14.402344 14.953125 C 14.417969 17.128906 14.417969 17.109375 14.59375 17.535156 C 14.695312 17.789062 14.761719 17.890625 14.945312 18.117188 C 15.433594 18.726562 16.238281 19.050781 16.984375 18.9375 C 17.953125 18.792969 18.691406 18.105469 18.917969 17.136719 C 18.960938 16.957031 18.964844 16.523438 18.964844 12.109375 C 18.964844 7.597656 18.960938 7.273438 18.914062 7.09375 C 18.84375 6.804688 18.710938 6.515625 18.5625 6.304688 C 18.484375 6.199219 17.527344 5.214844 16.398438 4.078125 L 14.375 2.039062 L 14.042969 2.371094 L 13.707031 2.703125 L 14.855469 3.855469 C 15.664062 4.667969 16.011719 5.03125 16.027344 5.089844 C 16.097656 5.375 16.007812 5.546875 15.722656 5.691406 C 15.113281 6 14.675781 6.53125 14.496094 7.1875 C 14.429688 7.414062 14.425781 7.988281 14.480469 8.210938 C 14.59375 8.652344 14.78125 8.980469 15.105469 9.308594 C 15.433594 9.636719 15.761719 9.824219 16.203125 9.9375 C 16.449219 9.996094 16.976562 9.984375 17.238281 9.910156 C 17.625 9.800781 17.835938 9.847656 17.957031 10.070312 C 18.007812 10.164062 18.007812 10.296875 18 13.59375 L 17.992188 17.023438 L 17.929688 17.179688 C 17.613281 17.964844 16.652344 18.25 15.9375 17.769531 C 15.757812 17.652344 15.558594 17.40625 15.472656 17.203125 C 15.414062 17.050781 15.414062 17.042969 15.398438 14.984375 L 15.386719 12.914062 L 15.308594 12.695312 C 15.21875 12.445312 15.125 12.300781 14.933594 12.121094 C 14.742188 11.9375 14.65625 11.886719 14.410156 11.800781 L 14.191406 11.726562 L 13.117188 11.707031 L 12.042969 11.695312 L 11.957031 11.613281 C 11.910156 11.5625 11.855469 11.503906 11.839844 11.472656 C 11.8125 11.429688 11.804688 10.210938 11.792969 6.6875 C 11.773438 1.480469 11.789062 1.917969 11.609375 1.46875 C 11.410156 0.972656 10.917969 0.476562 10.410156 0.261719 C 9.921875 0.0585938 10.242188 0.0703125 6.035156 0.0664062 C 3.105469 0.0625 2.210938 0.0664062 2.039062 0.09375 Z M 9.929688 1.078125 C 10.375 1.21875 10.730469 1.617188 10.820312 2.078125 C 10.839844 2.179688 10.847656 4.808594 10.847656 9.9375 C 10.847656 17.5625 10.847656 17.648438 10.792969 17.757812 C 10.761719 17.816406 10.699219 17.894531 10.648438 17.929688 L 10.558594 17.992188 L 1.289062 17.992188 L 1.203125 17.933594 C 1.15625 17.894531 1.097656 17.828125 1.070312 17.773438 C 1.03125 17.6875 1.027344 17.019531 1.027344 9.878906 C 1.027344 2.105469 1.027344 2.078125 1.082031 1.910156 C 1.21875 1.511719 1.507812 1.222656 1.902344 1.085938 C 2.0625 1.03125 2.113281 1.03125 5.914062 1.027344 C 9.613281 1.027344 9.769531 1.03125 9.929688 1.078125 Z M 17.164062 6.484375 C 17.53125 6.625 17.835938 6.957031 17.953125 7.320312 C 18.023438 7.550781 18.027344 7.898438 17.953125 8.125 C 17.75 8.78125 17.042969 9.171875 16.382812 9.003906 C 15.925781 8.882812 15.597656 8.589844 15.453125 8.164062 C 15.375 7.941406 15.375 7.507812 15.457031 7.273438 C 15.578125 6.910156 15.914062 6.589844 16.292969 6.464844 C 16.519531 6.390625 16.949219 6.402344 17.164062 6.484375 Z M 17.164062 6.484375 " />
          <path d="M 6.375 1.304688 C 6.367188 1.328125 5.851562 2.074219 5.230469 2.96875 C 4.609375 3.863281 4.09375 4.609375 4.085938 4.625 C 4.074219 4.652344 4.21875 4.660156 4.746094 4.660156 L 5.414062 4.660156 L 5.398438 4.765625 C 5.332031 5.171875 5.082031 6.921875 5.089844 6.929688 C 5.09375 6.933594 5.675781 6.25 6.382812 5.40625 L 7.667969 3.871094 L 6.882812 3.863281 C 6.285156 3.855469 6.105469 3.847656 6.105469 3.820312 C 6.105469 3.804688 6.171875 3.242188 6.257812 2.582031 C 6.398438 1.464844 6.425781 1.191406 6.375 1.304688 Z M 6.375 1.304688 " />
          <path d="M 6.375 6.714844 C 6.367188 6.738281 5.851562 7.484375 5.230469 8.378906 C 4.609375 9.273438 4.09375 10.019531 4.085938 10.035156 C 4.074219 10.0625 4.21875 10.070312 4.746094 10.070312 L 5.414062 10.070312 L 5.398438 10.175781 C 5.332031 10.582031 5.082031 12.332031 5.089844 12.339844 C 5.09375 12.34375 5.675781 11.660156 6.382812 10.816406 L 7.667969 9.28125 L 6.882812 9.273438 C 6.285156 9.265625 6.105469 9.257812 6.105469 9.230469 C 6.105469 9.214844 6.171875 8.652344 6.257812 7.992188 C 6.398438 6.875 6.425781 6.601562 6.375 6.714844 Z M 6.375 6.714844 " />
          <path d="M 6.375 12.125 C 6.367188 12.148438 5.851562 12.894531 5.230469 13.789062 C 4.609375 14.683594 4.09375 15.429688 4.085938 15.445312 C 4.074219 15.472656 4.21875 15.480469 4.746094 15.480469 L 5.414062 15.480469 L 5.398438 15.585938 C 5.332031 15.992188 5.082031 17.742188 5.089844 17.75 C 5.09375 17.753906 5.675781 17.070312 6.382812 16.226562 L 7.667969 14.691406 L 6.882812 14.683594 C 6.285156 14.675781 6.105469 14.667969 6.105469 14.640625 C 6.105469 14.625 6.171875 14.0625 6.257812 13.402344 C 6.398438 12.285156 6.425781 12.011719 6.375 12.125 Z M 6.375 12.125 " />
        </g>
      </svg>
    </div>
  )
}

const LastUpdated = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="100%"
        height="100%"
        viewBox="0 -960 960 960"
        fill={fill}
      >
        <path d="M477-140.001q-137.845 0-235.499-95.692-97.653-95.692-101.5-234.152h45.384Q190.001-351 273.693-268.192 357.385-185.385 477-185.385q124.307 0 210.577-87.077 86.269-87.077 86.269-211.384 0-122.077-86.885-206.423Q600.077-774.615 477-774.615q-64.538 0-121.73 28.308Q298.078-718 254.847-670.462h100.769v45.384H175.464v-179.921h45.384v103.692q49.307-55.23 115.807-86.961Q403.154-819.999 477-819.999q70.769 0 132.922 26.462 62.154 26.461 108.769 72.461t73.577 107.538Q819.229-552 819.229-481.615q0 70.769-26.961 133.114-26.962 62.346-73.577 108.462-46.615 46.115-108.769 73.076Q547.769-140.001 477-140.001ZM608.846-322.77 458.308-471.693v-210.538h45.384v191.693l137.769 135.154-32.615 32.614Z" />
      </svg>
    </div>
  )
}
const ArrowUp = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="m282-204.651-55.566-56.131L480-514.348l253.566 253.566L678-204.651 480-403.216 282-204.651Zm0-266.001-55.566-55.566L480-780.349l253.566 254.131L678-470.652 480-669.217 282-470.652Z" />
      </svg>
    </div>
  )
}
const liveEncoded = ({
  fill = Colors.primary,
  width = '100%',
  height = '100%',
}) => {
  return encodeURIComponent(
    `<svg 
    xmlns="http://www.w3.org/2000/svg" 
    height="${height}" 
    viewBox="0 -960 960 960" 
    width="${width}" 
    fill="${fill}" >
    <path d="M197-197q-54-54-85.5-126.5T80-480q0-84 31.5-156.5T197-763l43 43q-46 46-73 107.5T140-480q0 71 26.5 132T240-240l-43 43Zm113-113q-32-32-51-75.5T240-480q0-51 19-94.5t51-75.5l43 43q-24 24-38.5 56.5T300-480q0 38 14 70t39 57l-43 43Zm170-90q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm170 90-43-43q24-24 38.5-56.5T660-480q0-38-14-70t-39-57l43-43q32 32 51 75.5t19 94.5q0 50-19 93.5T650-310Zm113 113-43-43q46-46 73-107.5T820-480q0-71-26.5-132T720-720l43-43q54 55 85.5 127.5T880-480q0 83-31.5 155.5T763-197Z"/>
    </svg>`,
  )
}
const notLiveEncoded = ({
  fill = Colors.primary,
  width = '100%',
  height = '100%',
}) => {
  return encodeURIComponent(
    `<svg 
    xmlns="http://www.w3.org/2000/svg" 
    height="${height}" 
    viewBox="0 -960 960 960" 
    width="${width}" 
    fill="${fill}" >
    <path d="M813-61 317-557q-8 17-12.5 37t-4.5 40q0 38 14 70t39 57l-43 43q-32-32-51-75.5T240-480q0-34 8.5-64.5T273-601l-72-72q-29 42-45 90.5T140-480q0 71 26.5 132T240-240l-43 43q-54-54-85.5-126.5T80-480q0-67 20.5-127T157-717l-96-96 43-43 752 752-43 43Zm-11-183-43-43q29-42 45-90.5T820-480q0-71-26.5-132T720-720l43-43q54 55 85.5 127.5T880-480q0 66-20.5 125.5T802-244ZM687-359l-44-44q8-17 12.5-37t4.5-40q0-38-14-70t-39-57l43-43q32 32 51 75.5t19 94.5q0 33-8.5 63.5T687-359Z"/>
    </svg>`,
  )
}

const refresh = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M480-160q-133 0-226.5-93.5T160-480q0-133 93.5-226.5T480-800q85 0 149 34.5T740-671v-129h60v254H546v-60h168q-38-60-97-97t-137-37q-109 0-184.5 75.5T220-480q0 109 75.5 184.5T480-220q83 0 152-47.5T728-393h62q-29 105-115 169t-195 64Z" />
      </svg>
    </div>
  )
}

const hardReset = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M650.692-225.694 565-140.001l-70.768-70.769 85.692-86.076q-4.769-11.385-7.346-23.77-2.577-12.384-2.577-25.154 0-54.153 37.923-92.076 37.922-37.923 92.076-37.923 16.077 0 31.154 3.731 15.076 3.731 28.538 10.577L672-373.77l56 56 87.692-86.691q6.846 13.461 10.577 28.038 3.73 14.577 3.73 30.653 0 54.154-37.923 92.077Q754.154-215.77 700-215.77q-13.385 0-25.654-2.577t-23.654-7.347Zm157.229-341.999h-62.229q-27.538-84.538-99.577-138.423Q574.077-760 480-760q-117 0-198.5 81.5T200-480q0 78.154 38.462 141.808 38.462 63.655 101.539 99.347V-360H400v219.999H180.001V-200h113.233q-69.309-45-111.271-118.269T140.001-480q0-70.769 26.77-132.615 26.769-61.846 72.768-107.846 46-45.999 107.846-72.768 61.846-26.77 132.615-26.77 118.615 0 208.806 71.423 90.192 71.422 119.115 180.883Z" />
      </svg>
    </div>
  )
}

const Up = ({ className, height = 36, width = 36, fill = Colors.primary }) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="m296-358.463-42.153-42.152L480-626.768l226.153 226.153L664-358.463l-184-184-184 184Z" />
      </svg>
    </div>
  )
}

const Down = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M480-358.463 253.847-584.615 296-626.768l184 184 184-184 42.153 42.153L480-358.463Z" />
      </svg>
    </div>
  )
}

const HeatMap = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M480.134-120q-74.673 0-140.41-28.339-65.737-28.34-114.365-76.922-48.627-48.582-76.993-114.257Q120-405.194 120-479.866q0-74.673 28.339-140.41 28.34-65.737 76.922-114.365 48.582-48.627 114.257-76.993Q405.194-840 479.866-840q74.673 0 140.41 28.339 65.737 28.34 114.365 76.922 48.627 48.582 76.993 114.257Q840-554.806 840-480.134q0 74.673-28.339 140.41-28.34 65.737-76.922 114.365-48.582 48.627-114.257 76.993Q554.806-120 480.134-120ZM480-160q133 0 226.5-93.5T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160Zm0-200q-49.5 0-84.75-35.25T360-480q0-49.5 35.25-84.75T480-600q49.5 0 84.75 35.25T600-480q0 49.5-35.25 84.75T480-360Z" />
      </svg>
    </div>
  )
}

const Search = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        width="100%"
        height="100%"
        fill={fill}
      >
        <path d="M781.692-136.924 530.461-388.155q-30 24.769-69 38.769t-80.692 14q-102.55 0-173.582-71.014t-71.032-173.537q0-102.524 71.014-173.601 71.014-71.076 173.538-71.076 102.523 0 173.6 71.032T625.384-580q0 42.846-14.385 81.846-14.385 39-38.385 67.846l251.231 251.231-42.153 42.153Zm-400.923-258.46q77.308 0 130.962-53.654Q565.385-502.692 565.385-580q0-77.308-53.654-130.962-53.654-53.654-130.962-53.654-77.308 0-130.962 53.654Q196.154-657.308 196.154-580q0 77.308 53.653 130.962 53.654 53.654 130.962 53.654Z" />
      </svg>
    </div>
  )
}

const Undo = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24"
        viewBox="0 -960 960 960"
        width="24"
        fill={fill}
      >
        <path d="M280-200v-80h284q63 0 109.5-40T720-420q0-60-46.5-100T564-560H312l104 104-56 56-200-200 200-200 56 56-104 104h252q97 0 166.5 63T800-420q0 94-69.5 157T564-200H280Z" />
      </svg>
    </div>
  )
}

const Alert = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
      >
        <path d="M104.617-563.462q0-88.46 37.577-163.306 37.576-74.846 101.421-126.384l37 46.691q-53.461 43.231-84.73 106-31.269 62.769-31.269 136.999h-59.999Zm690.767 0q0-74.23-31.269-137.191-31.269-62.962-84.73-106.192l37-46.307q63.845 51.538 101.421 126.384 37.577 74.846 37.577 163.306h-59.999ZM180.001-204.616v-59.998h72.308v-298.463q0-80.692 49.807-142.692 49.808-62 127.885-79.307v-24.923q0-20.769 14.615-35.384 14.615-14.616 35.384-14.616t35.384 14.616q14.615 14.615 14.615 35.384v24.923q78.077 17.307 127.885 79.307 49.807 62 49.807 142.692v298.463h72.308v59.998H180.001ZM480-497.692Zm0 405.383q-29.923 0-51.115-21.192-21.192-21.192-21.192-51.115h144.614q0 29.923-21.192 51.115Q509.923-92.309 480-92.309ZM312.307-264.614h335.386v-298.463q0-69.462-49.116-118.577Q549.462-730.77 480-730.77q-69.462 0-118.577 49.116-49.116 49.115-49.116 118.577v298.463Z" />
      </svg>
    </div>
  )
}

const Timer = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
      >
        <path d="M360-840v-80h240v80H360Zm80 440h80v-240h-80v240Zm40 320q-74 0-139.5-28.5T226-186q-49-49-77.5-114.5T120-440q0-74 28.5-139.5T226-694q49-49 114.5-77.5T480-800q62 0 119 20t107 58l56-56 56 56-56 56q38 50 58 107t20 119q0 74-28.5 139.5T734-186q-49 49-114.5 77.5T480-80Zm0-80q116 0 198-82t82-198q0-116-82-198t-198-82q-116 0-198 82t-82 198q0 116 82 198t198 82Zm0-280Z" />
      </svg>
    </div>
  )
}

const Percentage = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
      >
        <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q64 0 123-24t104-69L480-480v-320q-134 0-227 93t-93 227q0 134 93 227t227 93Z" />
      </svg>
    </div>
  )
}
const PassKey = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
      >
        <path d="M120-160v-112q0-34 17.5-62.5T184-378q62-31 126-46.5T440-440q20 0 40 1.5t40 4.5q-4 58 21 109.5t73 84.5v80H120ZM760-40l-60-60v-186q-44-13-72-49.5T600-420q0-58 41-99t99-41q58 0 99 41t41 99q0 45-25.5 80T790-290l50 50-60 60 60 60-80 80ZM440-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm300 80q17 0 28.5-11.5T780-440q0-17-11.5-28.5T740-480q-17 0-28.5 11.5T700-440q0 17 11.5 28.5T740-400Z" />
      </svg>
    </div>
  )
}
const PendingActions = ({
  className,
  height = 36,
  width = 36,
  fill = Colors.primary,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
      >
        <path d="M680-80q-83 0-141.5-58.5T480-280q0-83 58.5-141.5T680-480q83 0 141.5 58.5T880-280q0 83-58.5 141.5T680-80Zm67-105 28-28-75-75v-112h-40v128l87 87Zm-547 65q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h167q11-35 43-57.5t70-22.5q40 0 71.5 22.5T594-840h166q33 0 56.5 23.5T840-760v250q-18-13-38-22t-42-16v-212h-80v120H280v-120h-80v560h212q7 22 16 42t22 38H200Zm280-640q17 0 28.5-11.5T520-800q0-17-11.5-28.5T480-840q-17 0-28.5 11.5T440-800q0 17 11.5 28.5T480-760Z" />
      </svg>
    </div>
  )
}
const ResendEmailIcon = ({ className, height = 24, width = 24, onClick }) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill={Colors.tooltipGrey}
        onClick={onClick}
      >
        <path d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z" />
      </svg>
    </div>
  )
}
const Bolt = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.black,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="m422-232 207-248H469l29-227-185 267h139l-30 208Zm-78.92 129.69 40-277.69h-185l329.61-475.77h49.23L537.31-540H757.3L392.31-102.31h-49.23ZM471-470Z" />
      </svg>
    </div>
  )
}

const MobileCharge = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M292.31-60q-29.92 0-51.12-21.19Q220-102.39 220-132.31v-695.38Q220-858 241-879q21-21 51.31-21h376.92q29.92 0 51.11 21.19 21.2 21.2 21.2 51.12v126.31q16.46 4.3 27.46 17.19 11 12.88 11 29.96v75.38q0 17.08-11 29.97-11 12.88-27.46 17.19v399.38q0 29.92-21.2 51.12Q699.15-60 669.23-60H292.31Zm0-60h376.92q5.38 0 8.85-3.46 3.46-3.46 3.46-8.85v-695.38q0-5.39-3.46-8.85-3.47-3.46-8.85-3.46H292.31q-5.39 0-8.85 3.46t-3.46 8.85v695.38q0 5.39 3.46 8.85t8.85 3.46ZM280-120v-720 720Zm181.54-175.39 110.77-221.53h-73.85v-147.69L387.69-443.08h73.85v147.69Z" />
      </svg>
    </div>
  )
}
const AverageTime = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M201.85-470H320q8.31 0 15.61 4.15 7.31 4.16 11.16 12.47L400-347.69l133.23-265.69q8.31-17.23 26.96-17.23 18.66 0 26.96 17.23L658.85-470h99.3Q747-575.85 667.65-647.92 588.31-720 480-720t-187.65 72.08Q213-575.85 201.85-470ZM480-160q108.31 0 187.65-72.08Q747-304.15 758.15-410H640q-8.31 0-15.61-4.15-7.31-4.16-11.16-12.47L560-532.31 426.77-266.23q-8.31 17.23-26.96 17.04-18.66-.2-26.96-17.43L301.15-410h-99.3q11.15 105.85 90.5 177.92Q371.69-160 480-160Zm0 60q-70.15 0-132-26.77-61.85-26.77-108.15-73.08-46.31-46.3-73.08-108.15Q140-369.85 140-440h60q0 116 82 198t198 82q116 0 198-82t82-198h60q0 70.15-26.77 132-26.77 61.85-73.08 108.15-46.3 46.31-108.15 73.08Q550.15-100 480-100ZM140-440q0-70.15 26.77-132 26.77-61.85 73.08-108.15 46.3-46.31 108.15-73.08Q409.85-780 480-780q60.08 0 115.73 20.39 55.65 20.38 103.35 58.38l49.84-49.84 42.15 42.15-49.84 49.84q38 47.7 58.38 103.35Q820-500.08 820-440h-60q0-116-82-198t-198-82q-116 0-198 82t-82 198h-60Zm227.69-410v-60h224.62v60H367.69ZM480-160q-116 0-198-82t-82-198q0-116 82-198t198-82q116 0 198 82t82 198q0 116-82 198t-198 82Zm0-280Z" />
      </svg>
    </div>
  )
}
const Database = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M480-140q-145.61 0-242.81-41.12Q140-222.23 140-283.85V-680q0-57.92 99.54-98.96Q339.08-820 480-820q140.92 0 240.46 41.04Q820-737.92 820-680v396.15q0 61.62-97.19 102.73Q625.61-140 480-140Zm0-461.69q87.46 0 176.12-24.73 88.65-24.73 102.73-53.35-13.7-29.38-101.66-54.81Q569.23-760 480-760q-89.08 0-176.58 24.73-87.5 24.73-103.04 53.96 15.16 30 102.27 54.81 87.12 24.81 177.35 24.81Zm0 200.15q41.62 0 81-4t75.27-11.69q35.88-7.69 67.19-19.08 31.31-11.38 56.54-25.77V-604q-25.23 14.38-56.54 25.77-31.31 11.38-67.19 19.07-35.89 7.7-75.27 11.7-39.38 4-81 4-42.38 0-82.58-4.2-40.19-4.19-75.88-11.88t-66.5-18.88Q224.23-589.62 200-604v141.92q24.23 14.39 55.04 25.58 30.81 11.19 66.5 18.88 35.69 7.7 75.88 11.89 40.2 4.19 82.58 4.19ZM480-200q48.69 0 95.62-6.42 46.92-6.43 85.38-17.54 38.46-11.12 64.88-25.81 26.43-14.69 34.12-30.85v-121.46q-25.23 14.39-56.54 25.77-31.31 11.39-67.19 19.08-35.89 7.69-75.27 11.69-39.38 4-81 4-42.38 0-82.58-4.19-40.19-4.19-75.88-11.89-35.69-7.69-66.5-18.88-30.81-11.19-55.04-25.58V-280q7.69 16.54 33.81 30.73 26.11 14.19 64.57 25.31 38.47 11.11 85.7 17.54Q431.31-200 480-200Z" />
      </svg>
    </div>
  )
}
const EvStation = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
}) => {
  return (
    <div className={className} style={{ height: height, width: width }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="m343.08-217.69 85.38-144.62h-51.15v-110.38l-85.77 144.61h51.54v110.39ZM240-550h240v-197.69q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H252.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46V-550Zm0 350h240v-290H240v290Zm-60 60v-607.69Q180-778 201-799q21-21 51.31-21h215.38Q498-820 519-799q21 21 21 51.31v260h44.61q27.46 0 46.81 19.34 19.35 19.35 19.35 46.81v184.62q0 19.3 15.73 34.27 15.73 14.96 35.42 14.96 20.69 0 35.92-14.96 15.24-14.97 15.24-34.27v-365.39h-11.93q-15.46 0-25.81-10.34Q705-623 705-638.46V-710h18.08v-52.31h35.38V-710h36.92v-52.31h35.39V-710h18.07v71.54q0 15.46-10.34 25.81-10.35 10.34-25.81 10.34h-11.92v365.39q0 39.3-28.77 68.11Q743.23-140 701.92-140q-40.31 0-69.58-28.81-29.26-28.81-29.26-68.11v-184.62q0-8.46-5-13.46t-13.47-5H540v300H180Zm300-60H240h240Z" />
      </svg>
    </div>
  )
}

const ArrowOutward = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
  transform,
}) => {
  return (
    <div
      className={className}
      style={{
        height: height,
        width: width,
        color: fill,
        transform: transform,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M251.77-254.23 210-296l393.62-394H245.77v-60h460v460h-60v-357.85l-394 393.62Z" />
      </svg>
    </div>
  )
}
const CalendarMonth = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M212.31-100Q182-100 161-121q-21-21-21-51.31v-535.38Q140-738 161-759q21-21 51.31-21h55.38v-84.61h61.54V-780h303.08v-84.61h60V-780h55.38Q778-780 799-759q21 21 21 51.31v535.38Q820-142 799-121q-21 21-51.31 21H212.31Zm0-60h535.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-375.38H200v375.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85ZM200-607.69h560v-100q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H212.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v100Zm0 0V-720v112.31Zm280 210.77q-14.69 0-25.04-10.35-10.34-10.34-10.34-25.04 0-14.69 10.34-25.04 10.35-10.34 25.04-10.34t25.04 10.34q10.34 10.35 10.34 25.04 0 14.7-10.34 25.04-10.35 10.35-25.04 10.35Zm-160 0q-14.69 0-25.04-10.35-10.34-10.34-10.34-25.04 0-14.69 10.34-25.04 10.35-10.34 25.04-10.34t25.04 10.34q10.34 10.35 10.34 25.04 0 14.7-10.34 25.04-10.35 10.35-25.04 10.35Zm320 0q-14.69 0-25.04-10.35-10.34-10.34-10.34-25.04 0-14.69 10.34-25.04 10.35-10.34 25.04-10.34t25.04 10.34q10.34 10.35 10.34 25.04 0 14.7-10.34 25.04-10.35 10.35-25.04 10.35ZM480-240q-14.69 0-25.04-10.35-10.34-10.34-10.34-25.03 0-14.7 10.34-25.04 10.35-10.35 25.04-10.35t25.04 10.35q10.34 10.34 10.34 25.04 0 14.69-10.34 25.03Q494.69-240 480-240Zm-160 0q-14.69 0-25.04-10.35-10.34-10.34-10.34-25.03 0-14.7 10.34-25.04 10.35-10.35 25.04-10.35t25.04 10.35q10.34 10.34 10.34 25.04 0 14.69-10.34 25.03Q334.69-240 320-240Zm320 0q-14.69 0-25.04-10.35-10.34-10.34-10.34-25.03 0-14.7 10.34-25.04 10.35-10.35 25.04-10.35t25.04 10.35q10.34 10.34 10.34 25.04 0 14.69-10.34 25.03Q654.69-240 640-240Z" />
      </svg>
    </div>
  )
}
const ModeHeat = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Icons,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M240-400q0 60.46 28.89 112.54 28.88 52.08 79.42 84-4.46-8.46-6.39-16.89Q340-228.77 340-238q0-27.77 10.66-52.31 10.65-24.54 30.57-44.46L480-431.92l99.15 97.15q19.93 19.92 30.39 44.46T620-238q0 9.23-1.92 17.65-1.93 8.43-6.39 16.89 50.54-31.92 79.42-84Q720-339.54 720-400q0-50-18.5-94.5T648-574q-20 13-42 19.5t-45 6.5q-62.38 0-107.88-41-45.5-41-52.12-101.77-39 32.62-69 68.12-30 35.5-50.5 72.38-20.5 36.89-31 74.89T240-400Zm240 52-57 56q-11 11-17 25t-6 29q0 32 23.5 55t56.5 23q33 0 56.5-23t23.5-55q0-16-6-29.5T537-292l-57-56Zm-20-456.23V-708q0 42.46 29.27 71.23Q518.54-608 561-608q18.38 0 35.04-6.92 16.65-6.92 30.58-20.39l17.61-17.76q63.23 40.46 99.5 107.96T780-400q0 125.54-87.23 212.77T480-100q-125.54 0-212.77-87.23T180-400q0-115.92 75.54-223.08Q331.08-730.23 460-804.23Z" />
      </svg>
    </div>
  )
}
const LocationOn = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Analytics.Icons,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M480.07-485.39q29.85 0 51.04-21.26 21.2-21.26 21.2-51.11 0-29.85-21.26-51.05Q509.79-630 479.93-630q-29.85 0-51.04 21.26-21.2 21.26-21.2 51.12 0 29.85 21.26 51.04 21.26 21.19 51.12 21.19ZM480-99.62Q329-230.46 253.54-343.15q-75.46-112.7-75.46-206.93 0-138.46 89.57-224.19Q357.23-860 480-860t212.35 85.73q89.57 85.73 89.57 224.19 0 94.23-75.46 206.93Q631-230.46 480-99.62Z" />
      </svg>
    </div>
  )
}
const MapPinPreview = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.Analytics.Icons,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M259-212q20.92-19.92 47.35-47.77 26.42-27.84 50.57-59.77 24.16-31.92 40.12-65.92Q413-419.47 413-450.77q0-69.23-43.31-113.65-43.32-44.43-110.69-44.43-67.38 0-110.69 44.43Q105-520 105-450.77q0 31.3 15.96 65.31 15.96 34 40.12 65.92 24.15 31.93 50.57 59.77Q238.08-231.92 259-212ZM100-100v-60h126.46q-28-25.62-60.34-59.58-32.35-33.96-59.89-73.5-26-36.84-43.61-77.04Q45-410.31 45-450.58q0-93.96 61.15-156.11 61.16-62.16 152.89-62.16 91.73 0 152.84 62.16Q473-544.54 473-450.58q0 40.27-17.62 80.46-17.61 40.2-43.61 77.04-27.54 39.54-60.08 73.5T291.54-160H860v60H100Zm499.38-488.69Zm-2.84 325.23-65.77-106 31.54-62.85 34.23 55.54 34.23-55.54H800v-355.38q0-5.39-3.46-8.85t-8.85-3.46H405.77q-5.39 0-8.85 3.46t-3.46 8.85v52.31h-60v-52.31q0-30.31 21-51.31 21-21 51.31-21h381.92Q818-860 839-839q21 21 21 51.31v343.07q0 30.31-21 51.31-21 21-51.31 21H664.61l-68.07 108.85Zm-72-254.62 74.84-45.15 74.47 45.15-19.47-85.07 66.62-58-87.69-7.23-33.93-80.46-34.19 80.3-87.8 7.39 66.61 58-19.46 85.07ZM259.09-408.46q21.83 0 37.02-15.28 15.2-15.29 15.2-37.12t-15.29-37.22q-15.28-15.38-37.11-15.38t-37.03 15.36q-15.19 15.36-15.19 37.31 0 21.94 15.29 37.14 15.28 15.19 37.11 15.19Zm-.09-52.31Z" />
      </svg>
    </div>
  )
}
const Distance = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.primary,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M480-100q-101.38 0-165.69-29.1T250-204.23q0-21.31 16.04-40.08t44.35-32.23l47.23 42.85q-12.85 5.15-27.01 12.84-14.15 7.7-19.38 16.23 9.92 17.93 59.04 31.27Q419.38-160 479.81-160q60.42 0 110.04-13.35 49.61-13.34 59.54-31.27-5.08-9.15-20.5-16.84-15.43-7.69-29.27-12.85l46.61-43.46q30.69 14.08 47.23 32.85Q710-226.15 710-204.4q0 46.11-64.31 75.25Q581.38-100 480-100Zm1-195q99.38-75.31 149.19-149.19Q680-518.08 680-590.92q0-103.53-64.81-156.3-64.81-52.78-135-52.78T345-747.19q-65 52.8-65 156.38 0 68.04 49.19 141.12T481-295Zm-1 75q-130.93-97.89-195.46-190.14Q220-502.38 220-590.86q0-66.83 23.58-117.06 23.58-50.23 60.88-84.12 37.31-33.88 83.72-50.92Q434.58-860 480.06-860t91.82 17.04q46.35 17.04 83.66 50.92 37.3 33.89 60.88 84.15Q740-657.63 740-590.92q0 88.49-64.54 180.75Q610.93-317.91 480-220Zm.19-304.23q29.73 0 50.92-21 21.2-21 21.2-51.12 0-30.11-21.24-51.3-21.24-21.2-51.07-21.2-29.54 0-50.92 21.24-21.39 21.25-21.39 51.07 0 30.31 21.39 51.31 21.38 21 51.11 21Zm-.19-72.31Z" />
      </svg>
    </div>
  )
}

const Statistics = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.black,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M488.85-90 359.62-691.23 263.92-250H90v-60h125.69l112.62-520h63.23L522-222.61 607.31-590h65l72 280H870v60H697.69l-56.46-221.08L552.69-90h-63.84Z" />
      </svg>
    </div>
  )
}
const Trend = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.black,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M333.85-441.69v-264.46h92.3v264.46L380-486.16l-46.15 44.47Zm186.92 74.61v-499.07h92.3v406.77l-92.3 92.3ZM146.16-255.23v-290.92h92.3v198.61l-92.3 92.31ZM143.85-128l234.92-234.92 142 122L767.85-488H690v-60h180v180h-60v-77.85L523.23-159.08l-142-122L228.15-128h-84.3Z" />
      </svg>
    </div>
  )
}
const IdCard = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.black,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M563.08-450.77h181.53v-60H563.08v60Zm0-115.38h181.53v-60H563.08v60Zm-347.69 232.3h292.3v-14.3q0-40-39.58-62.85-39.57-22.85-106.57-22.85T254.96-411q-39.57 22.85-39.57 62.85v14.3Zm146.15-152.3q29.15 0 49.57-20.43 20.43-20.42 20.43-49.57 0-29.16-20.43-49.58-20.42-20.42-49.57-20.42t-49.58 20.42q-20.42 20.42-20.42 49.58 0 29.15 20.42 49.57 20.43 20.43 49.58 20.43ZM172.31-180Q142-180 121-201q-21-21-21-51.31v-455.38Q100-738 121-759q21-21 51.31-21h615.38Q818-780 839-759q21 21 21 51.31v455.38Q860-222 839-201q-21 21-51.31 21H172.31Zm0-60h615.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-455.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H172.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v455.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85ZM160-240v-480 480Z" />
      </svg>
    </div>
  )
}
const Map = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.black,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="m600-141.54-240-84-172.15 66.61q-17.69 6.85-32.77-3.92Q140-173.62 140-192.31v-524.61q0-11.85 6.35-21.27 6.34-9.42 17.81-13.65L360-818.46l240 84 172.15-66.61q17.69-6.85 32.77 3.34Q820-787.54 820-769.23v527.69q0 12.23-6.92 21.46-6.93 9.23-18.77 13.46L600-141.54Zm-30-73.38v-468l-180-62.93v468l180 62.93Zm60 0L760-258v-474l-130 49.08v468ZM200-228l130-49.85v-468L200-702v474Zm430-454.92v468-468Zm-300-62.93v468-468Z" />
      </svg>
    </div>
  )
}
const Analytics = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.white,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M294.62-290h59.99v-190h-59.99v190Zm310.77 0h59.99v-390h-59.99v390ZM450-290h60v-110h-60v110Zm0-190h60v-80h-60v80ZM212.31-140Q182-140 161-161q-21-21-21-51.31v-535.38Q140-778 161-799q21-21 51.31-21h535.38Q778-820 799-799q21 21 21 51.31v535.38Q820-182 799-161q-21 21-51.31 21H212.31Zm0-60h535.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-535.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H212.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v535.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85ZM200-760v560-560Z" />
      </svg>
    </div>
  )
}
const Tariff = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.white,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M856-390 570-104q-12 12-27 18t-30 6q-15 0-30-6t-27-18L103-457q-11-11-17-25.5T80-513v-287q0-33 23.5-56.5T160-880h287q16 0 31 6.5t26 17.5l352 353q12 12 17.5 27t5.5 30q0 15-5.5 29.5T856-390ZM513-160l286-286-353-354H160v286l353 354ZM260-640q25 0 42.5-17.5T320-700q0-25-17.5-42.5T260-760q-25 0-42.5 17.5T200-700q0 25 17.5 42.5T260-640Zm220 160Z" />
      </svg>
    </div>
  )
}
const EncodedBlock = (fill = Colors.primary) => {
  return encodeURIComponent(`
    <svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
      fill="${fill}"
    >
<path d="m696-100-42.15-42.15 84-84-84-83.62L696-351.92l84 84 83.62-84 42.15 42.15-83 83.62 83 84L863.62-100 780-183l-84 83Zm-216 0q-78.77 0-148.11-29.96-69.35-29.96-120.66-81.27-51.31-51.31-81.27-120.66Q100-401.23 100-480q0-78.77 29.96-148.11 29.96-69.35 81.27-120.66 51.31-51.31 120.66-81.27Q401.23-860 480-860q78.77 0 148.11 29.96 69.35 29.96 120.66 81.27 51.31 51.31 81.27 120.66Q860-558.77 860-480q0 9.23-.31 18.08-.31 8.84-1.31 18.07h-60.61q1.61-9.23 1.92-18.07.31-8.85.31-18.08 0-21.92-2.88-43.65-2.89-21.74-9.04-43.27h-148.7q3.77 21.53 5.47 43.27 1.69 21.73 1.69 43.65 0 9.23-.19 18.08-.2 8.84-.81 18.07h-60q.61-9.23.81-18.07.19-8.85.19-18.08 0-21.92-1.69-43.65-1.7-21.74-5.46-43.27H380.61q-3.76 21.53-5.46 43.27-1.69 21.73-1.69 43.65 0 21.92 1.69 43.65 1.7 21.74 5.46 43.27h171.7v60H394.38q13.16 47.23 34.27 90.58 21.12 43.35 51.35 81.65 16.85 0 33.38-1.8 16.54-1.81 33.39-3.81l13.77 58q-20.69 4.23-40.27 6.34Q500.69-100 480-100ZM171.92-393.08h148.7q-3.77-21.53-5.47-43.27-1.69-21.73-1.69-43.65 0-21.92 1.69-43.65 1.7-21.74 5.47-43.27h-148.7q-6.15 21.53-9.04 43.27Q160-501.92 160-480q0 21.92 2.88 43.65 2.89 21.74 9.04 43.27Zm25.16-233.84h135.69q10.15-43.54 27.31-84.23 17.15-40.7 42.46-77.77-67.31 14.92-120.73 57.38-53.43 42.46-84.73 104.62Zm205.46 455.84q-24.15-37.46-41.5-78.15-17.35-40.69-28.27-83.85H197.08q31.3 61.77 84.92 104.23 53.62 42.47 120.54 57.77Zm-8.16-455.84h171.24q-12.77-47.23-34.47-90.19-21.69-42.97-51.15-82.04-29.85 38.3-51.35 81.65-21.5 43.35-34.27 90.58Zm232.85 0h135.69q-31.3-62.16-84.73-104.81-53.42-42.66-120.73-57.19 24.15 37.46 40.92 78.34 16.77 40.89 28.85 83.66Z"/></svg>  `)
}
const EncodedUnblock = (fill = Colors.primary) => {
  return encodeURIComponent(`
    <svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
      fill="${fill}"
    >
<path d="M480-100q-78.15 0-147.5-29.96t-120.96-81.58q-51.62-51.61-81.58-120.96T100-480q0-78.77 29.96-147.81t81.58-120.65q51.61-51.62 120.96-81.58T480-860q78.77 0 147.81 29.96t120.65 81.58q51.62 51.61 81.58 120.65T860-480q0 78.15-29.96 147.5t-81.58 120.96q-51.61 51.62-120.65 81.58T480-100Zm0-60.85q30.62-40.61 51.54-81.92 20.92-41.31 34.08-90.31H394.38q13.93 50.54 34.47 91.85 20.53 41.31 51.15 80.38Zm-77.46-11q-23-33-41.31-75.03-18.31-42.04-28.46-86.2H197.08q31.69 62.31 85 104.7 53.31 42.38 120.46 56.53Zm154.92 0q67.15-14.15 120.46-56.53 53.31-42.39 85-104.7H627.23q-12.08 44.54-30.39 86.58-18.3 42.04-39.38 74.65ZM171.92-393.08h148.7q-3.77-22.3-5.47-43.73-1.69-21.42-1.69-43.19 0-21.77 1.69-43.19 1.7-21.43 5.47-43.73h-148.7q-5.77 20.38-8.84 42.38-3.08 22-3.08 44.54t3.08 44.54q3.07 22 8.84 42.38Zm208.69 0h198.78q3.76-22.3 5.46-43.34 1.69-21.04 1.69-43.58t-1.69-43.58q-1.7-21.04-5.46-43.34H380.61q-3.76 22.3-5.46 43.34-1.69 21.04-1.69 43.58t1.69 43.58q1.7 21.04 5.46 43.34Zm258.77 0h148.7q5.77-20.38 8.84-42.38 3.08-22 3.08-44.54t-3.08-44.54q-3.07-22-8.84-42.38h-148.7q3.77 22.3 5.47 43.73 1.69 21.42 1.69 43.19 0 21.77-1.69 43.19-1.7 21.43-5.47 43.73Zm-12.15-233.84h135.69Q730.85-690 678.5-731.62q-52.35-41.61-121.04-56.92 23 34.92 40.92 76.39 17.93 41.46 28.85 85.23Zm-232.85 0h171.24q-13.93-50.16-35.04-92.43-21.12-42.27-50.58-79.8-29.46 37.53-50.58 79.8-21.11 42.27-35.04 92.43Zm-197.3 0h135.69q10.92-43.77 28.85-85.23 17.92-41.47 40.92-76.39-69.08 15.31-121.23 57.12-52.16 41.8-84.23 104.5Z"/></svg>  `)
}

const QueryStats = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.black,
  transform,
}) => {
  return (
    <div
      className={className}
      style={{
        height: height,
        width: width,
        color: fill,
        transform: transform,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M108.85-414.39 60-449.46 245-746l117.69 137.69 156.16-254.23 117.69 176.93L771.15-900l48.08 35.46-181.46 289-116.69-175.92L371-507.16l-118.31-138.3-143.84 231.07ZM572.31-240q45.07 0 76.19-31.12 31.12-31.12 31.12-76.19 0-45.08-31.13-76.19-31.12-31.12-76.19-31.12-45.07 0-76.19 31.12Q465-392.37 465-347.3q0 45.07 31.12 76.18Q527.24-240 572.31-240Zm205.15 140L667.15-210.31q-20.23 14.77-44.34 22.54-24.12 7.77-50.5 7.77-69.71 0-118.51-48.78Q405-277.56 405-347.24q0-69.68 48.78-118.53 48.78-48.84 118.46-48.84 69.68 0 118.53 48.79 48.84 48.8 48.84 118.51 0 26.39-7.77 50.69-7.76 24.31-22.53 44.54l109.92 110.31L777.46-100Z" />
      </svg>
    </div>
  )
}
const QrCode = ({
  className,
  height = 24,
  width = 24,
  onClick,
  fill = Colors.primary,
}) => {
  return (
    <div
      className={className}
      style={{ height: height, width: width, color: fill }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill={fill}
        onClick={onClick}
      >
        <path d="M140-520v-300h300v300H140Zm60-60h180v-180H200v180Zm-60 440v-300h300v300H140Zm60-60h180v-180H200v180Zm320-320v-300h300v300H520Zm60-60h180v-180H580v180Zm165 440v-75h75v75h-75ZM520-365v-75h75v75h-75Zm75 75v-75h75v75h-75Zm-75 75v-75h75v75h-75Zm75 75v-75h75v75h-75Zm75-75v-75h75v75h-75Zm0-150v-75h75v75h-75Zm75 75v-75h75v75h-75Z" />
      </svg>
    </div>
  )
}

const componentPropTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
}

const components = [
  BatteryProfile,
  BatteryProfileFilled,
  Tune,
  FindInPage,
  FindInPageFilled,
  DeleteSweep,
  DeleteSweepFilled,
  SystemUpdate,
  Restart,
  Edit,
  Done,
  Cancel,
  Delete,
  DeleteFilled,
  Move,
  Card,
  Admin,
  Globe,
  Expand,
  Add,
  Flash,
  Start,
  Stop,
  Unlock,
  UnlockFilled,
  StopFilled,
  StartFilled,
  ArrowUpSort,
  ArrowDownSort,
  Sync,
  CloudDownload,
  CloudDownloadFill,
  EventNote,
  EventNoteFill,
  EventBusy,
  EventBusyFill,
  Timelapse,
  File,
  Error,
  Refresh,
  Terminal,
  FlashMaterial,
  RemoveRounded,
  AddRounded,
  GoBack,
  Email,
  RFID,
  VirtualToken,
  Caution,
  Tag,
  VisibleFilled,
  NormalSpeedCharging,
  FastSpeedCharging,
  SuperSpeedCharging,
  ArrowUp,
  liveEncoded,
  notLiveEncoded,
  refresh,
  LastUpdated,
  hardReset,
  Up,
  Down,
  HeatMap,
  Search,
  Alert,
  Timer,
  Percentage,
  PassKey,
  PendingActions,
  ResendEmailIcon,
  Bolt,
  MobileCharge,
  AverageTime,
  Database,
  EvStation,
  ArrowOutward,
  CalendarMonth,
  ModeHeat,
  LocationOn,
  MapPinPreview,
  Distance,
  Statistics,
  Trend,
  IdCard,
  Map,
  Analytics,
  QueryStats,
  Tariff,
  EncodedBlock,
  EncodedUnblock,
  QrCode,
]

components.forEach((component) => {
  component.propTypes = componentPropTypes
})

export default {
  BatteryProfile,
  BatteryProfileFilled,
  Tune,
  FindInPage,
  FindInPageFilled,
  DeleteSweep,
  DeleteSweepFilled,
  SystemUpdate,
  Restart,
  Edit,
  Done,
  Cancel,
  Delete,
  DeleteFilled,
  Move,
  Card,
  Admin,
  Globe,
  Expand,
  Add,
  Flash,
  Start,
  Stop,
  Unlock,
  UnlockFilled,
  StopFilled,
  StartFilled,
  ArrowUpSort,
  ArrowDownSort,
  Sync,
  CloudDownload,
  CloudDownloadFill,
  ScheduleSend: EventNote,
  ScheduleSendFill: EventNoteFill,
  CancelScheduleSend: EventBusy,
  CancelScheduleSendFill: EventBusyFill,
  Timelapse,
  File,
  Error,
  Refresh,
  Terminal,
  FlashMaterial,
  RemoveRounded,
  AddRounded,
  GoBack,
  Email,
  RFID,
  VirtualToken,
  Caution,
  Tag,
  VisibleFilled,
  EncodedUnlock,
  EncodedLock,
  NormalSpeedCharging,
  FastSpeedCharging,
  SuperSpeedCharging,
  ArrowUp,
  liveEncoded,
  notLiveEncoded,
  refresh,
  LastUpdated,
  hardReset,
  Up,
  Down,
  HeatMap,
  Search,
  Undo,
  Alert,
  Timer,
  Percentage,
  PassKey,
  PendingActions,
  ResendEmailIcon,
  Bolt,
  MobileCharge,
  AverageTime,
  Database,
  EvStation,
  ArrowOutward,
  CalendarMonth,
  ModeHeat,
  LocationOn,
  MapPinPreview,
  Distance,
  Statistics,
  Trend,
  IdCard,
  Map,
  Analytics,
  QueryStats,
  Tariff,
  EncodedBlock,
  EncodedUnblock,
  QrCode,
}
